import { shopDueDate, type ShopDateItem } from './index';

/**
 * The line item due soonest by shop due date, counting a Vendor App revision.
 * The order detail API sends `revised_partner_ship_date` but not
 * `shop_due_date`, so sorting on `shop_due_date || required_partner_ship_date`
 * ignored revisions and picked whichever line came first.
 */
export function soonestShopLine<T extends ShopDateItem>(
	items: readonly T[] | null | undefined
): T | undefined {
	return [...(items ?? [])]
		.filter((item) => shopDueDate(item))
		.sort((a, b) => shopDueDate(a).localeCompare(shopDueDate(b)))[0];
}
